var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.105h30v15.789H0V7.105Z",
    style: {
      fill: "#bf0a30"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,9.258h30M30,12.129H0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,12.847H0v-1.435h30v1.435ZM30,9.976H0v-1.435h30v1.435Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.105h7.177v7.895H0v-7.895Z",
    style: {
      fill: "#002868"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30M30,17.871H0M0,20.742h30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,21.459H0v-1.435h30v1.435ZM30,18.589H0v-1.435h30v1.435ZM30,15.718H0v-1.435h30v1.435Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.589,8.541l-.665,2.048,1.024.333-.359-2.381Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M3.589,8.541l.665,2.048-1.024.333.359-2.381Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M5.636,10.028h-2.153v1.077l2.153-1.077Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M5.636,10.028l-1.742,1.266-.633-.871,2.375-.395Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M2.323,12.436l1.742-1.266-.633-.871-1.109,2.137Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M2.323,12.436l.665-2.048,1.024.333-1.689,1.715Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M4.854,12.436l-.665-2.048-1.024.333,1.689,1.715Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M4.854,12.436l-1.742-1.266.633-.871,1.109,2.137Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M1.541,10.028l1.742,1.266.633-.871-2.375-.395Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M1.541,10.028h2.153v1.077l-2.153-1.077Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/LR.26e4651885ce08370f1e8e90e894f76e.svg";
export { ForwardRef as ReactComponent };